<template>
  <div class="schermo d-flex align-items-center justify-content-center">
    <div class="form-login">
      <img src="../images/logo-esteso.png">
      <br>
      <form>
         <input class="inpu" v-model="formData.email" autocomplete="username" placeholder="Email">
          <br>
        <input
          type="password"
          @keyup.enter="handleLogin"
          class="inpu"
          autocomplete="current-password"
          v-model="formData.password"
          placeholder="Password"
        >
      </form>
      <br>
      <transition name="fade">
        <div class="arrow_box" v-if="errore">
          {{ errore }}
          <div v-if="verifica" @click="inviaVerifica" class="azione link">
            <u>Invia email di verifica</u>
          </div>
          <div v-if="reimposta" @click="reimpostaPass" class="azione link">
            <u>Password dimenticata?</u>
          </div>
          <div class="azione" v-if="esito">{{ esito }}</div>
        </div>
      </transition>
      <button @click="handleLogin" class="entra">Accedi</button>

      <div class="caricamento">
        <div v-if="connessione" class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
    </div>

    <div
      class="pie"
    >Termini e Condizioni &nbsp; &nbsp; | &nbsp;&nbsp; Norme sulla Privacy &nbsp;&nbsp; | &nbsp;&nbsp; Copyright &copy; 2018 Jestionale</div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["loginStates"])
  },
  name: "login",
  data: function() {
    return {
      errore: "",
      connessione: false,
      verifica: false,
      reimposta: false,
      esito: "",

      formData: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    handleLogin() {
      var self = this;
      const email = this.formData.email;
      const password = this.formData.password;
      this.$store
        .dispatch("loginStates/logIn", { email, password })
        .then(user => {
          console.log(user);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.caricamento {
  display: block;
  height: 40px;
  width: 40px;
  margin: 0 auto;
  margin-top: 30px;
}

.pie {
  -webkit-font-smoothing: antialiased;
  position: fixed;
  bottom: 15px;
  right: 40px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 16px;
}

.azione {
  font-size: 20px;
  margin-top: 20px;
  cursor: default;
}

.link {
  cursor: pointer !important;
}

.spinner {
  width: 40px;
  height: 40px;

  position: relative;
  margin: 0 auto;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: white;
  opacity: 0.8;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

.inpu {
  font-size: 15px;
  width: 330px;
  height: 60px;
  margin-top: 5px;
  background: transparent;
  color: white;
  border: solid 2px white;
  padding: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  font-weight: 500;
}
.arrow_box {
  margin-top: 10px;
  position: absolute;
  width: 300px;
  margin-left: -150px;
  background: #000000;
  left: 50%;
  padding: 40px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=71)";
  filter: alpha(opacity=71);
  -moz-opacity: 0.71;
  -khtml-opacity: 0.71;
  opacity: 0.71;
}
.arrow_box:after {
  bottom: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(0, 0, 0, 0);
  border-bottom-color: #000000;
  border-width: 10px;
  margin-left: -10px;
}
.inpu:focus {
  outline: none;
}
.entra {
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
  font-weight: 500;
  background-color: white;
  border: solid 2px white;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  width: 330px;
  height: 60px;
  margin-top: 5px;
  outline: none;
}
.entra:hover {
  background-color: #41cf4d;
  border: solid 2px #41cf4d;
  color: white;
  outline: none;
  border: none;
}
.entra:active {
  outline: none;
  border: none;
}
.entra:focus {
  outline: none;
  border: none;
}
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #f4f4f4;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #f4f4f4;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #f4f4f4;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: #f4f4f4;
}
.form-login {
  display: inline-block;
}
.schermo {
  position: absolute;
  width: 100vw;
  height: 100vh;
  color: #fff;
  background: linear-gradient(-45deg, #b7b7b7, #939393, #6eab07, #6ca012);
  background-size: 400% 400%;
  -webkit-animation: Gradient 15s ease infinite;
  -moz-animation: Gradient 15s ease infinite;
  animation: Gradient 15s ease infinite;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>